import db from "@/database";

export const findAll = () => db.chakra.toArray();
